import { Component, OnInit, Input } from '@angular/core';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import * as _ from 'lodash-es';
import { DatePipe } from '@angular/common';
import { BaseAuthenticatedComponent } from '../base-authenticated/base-authenticated.component';
import { NbToastrService } from '@nebular/theme';
import { NbRoleProvider } from '@nebular/security';
import { StatoGravidanza } from '@hm_app/@core/models/gravidanza';

@Component({
    selector: 'lista-gravidanze',
    templateUrl: './lista-gravidanze.component.html',
    styleUrls: ['./lista-gravidanze.component.scss'],
})
export class ListaGravidanzeComponent extends BaseAuthenticatedComponent implements OnInit {

    items: any;

    _filterCodFiscale: string;
    _filterCognome: string;
    _filterNumLibretto: string;

    _area_vasta_corrente_id: number;
    _distretto_corrente_id: number;
    _stato_gravidanza: string;

    _libretto_cartaceo: boolean;
    _struttura_corrente_id: number;

    _limit: number = 50;
    _page: number = 0;
    full_count: number;

    _created_to: Date;
    _created_from: Date;

    disableUpdating: boolean = false;

    datePipe = new DatePipe('en-US');

    get created_to(): Date {
        return this._created_to;
    }

    set created_to(d: Date) {
        this._created_to = d;
        this.updateItems();
    }

    get created_from(): Date {
        return this._created_from;
    }

    set created_from(d: Date) {
        this._created_from = d;
        this.updateItems();
    }

    get first_index_items(): number {
        return this.limit * this.page;
    }

    get last_index_items(): number {
        if (!this.items) { return 0; }
        return this.limit * this.page + this.items.length;
    }

    get limit(): number {
        return this._limit;
    }

    get page(): number {
        return this._page;
    }

    set page(value: number) {
        this._page = value;
        this.updateItems();
    }

    get offset(): number {
        return this.limit * this.page;
    }

    @Input() show_nome = false;
    @Input() show_cognome = false;
    @Input() show_codice_fiscale = false;
    @Input() show_cup = false;

    @Input() nascita = false;

    set filterCognome(filter: string) {
        this._filterCognome = filter;
    }
    get filterCognome(): string {
        return this._filterCognome;
    }

    set filterCodFiscale(filter: string) {
        this._filterCodFiscale = filter;
    }
    get filterCodFiscale(): string {
        return this._filterCodFiscale;
    }

    set filterNumLibretto(filter: string) {
        this._filterNumLibretto = filter;
    }

    get filterNumLibretto(): string {
        return this._filterNumLibretto;
    }

    set area_vasta_corrente_id(a: number) {
        if (a == -1) {
            a = null;
        }

        if (this._area_vasta_corrente_id == a) {
            return;
        }
        this._page = 0;

        this._area_vasta_corrente_id = a;
        this.distretto_corrente_id = null;
        this.updateItems();
    }

    get area_vasta_corrente_id(): number {
        return this._area_vasta_corrente_id;
    }

    set distretto_corrente_id(d: number) {
        if (d == -1) {
            d = null;
        }

        if (this._distretto_corrente_id == d) {
            return;
        }
        this._page = 0;

        this._distretto_corrente_id = d;
        this.updateItems();
    }

    get distretto_corrente_id(): number {
        return this._distretto_corrente_id;
    }

    set struttura_corrente_id(s: number) {
        if (s == -1) {
            s = null;
        }

        if (this._struttura_corrente_id == s) {
            return;
        }
        this._page = 0;

        this._struttura_corrente_id = s;
        this.updateItems();
    }

    get struttura_corrente_id(): number {
        return this._struttura_corrente_id;
    }

    set stato_gravidanza(stato: string) {
        if (stato == '-') {
            stato = null;
        }

        if (this._stato_gravidanza == stato) {
            return;
        }
        this._page = 0;

        this._stato_gravidanza = stato;
        this.updateItems();
    }

    get stato_gravidanza(): string {
        return this._stato_gravidanza;
    }

    set libretto_cartaceo(value: boolean) {
        if (this._libretto_cartaceo == value) {
            return;
        }
        this._page = 0;

        this._libretto_cartaceo = value;
        this.updateItems();
    }

    get libretto_cartaceo(): boolean {
        return this._libretto_cartaceo;
    }

    resetPage(doUpdate: boolean = true) {
        this._page = 0;
        if (doUpdate) {
            this.updateItems();
        }
    }

    resetFilters() {
        this._filterCodFiscale = null;
        this._filterNumLibretto = null;
        this._filterCognome = null;
        this._area_vasta_corrente_id = null;
        this._distretto_corrente_id = null;
        this._libretto_cartaceo = null;
        this._stato_gravidanza = null;
        this._struttura_corrente_id = null;
        this.resetPage(false);
        this.updateItems();
    }

    constructor(protected hmService: HappyMammaService,
        protected toastrService: NbToastrService,
        protected roleProvider: NbRoleProvider) {
        super(hmService, toastrService, roleProvider);
    }

    async updateItemsFromInputString(){
        this._page = 0;
        await this.updateItems();
    }

    async updateItems() {
        if (this.disableUpdating) {
            return;
        }

        const filters = {};

        if (this.filterCognome) {
            const cogn = this.filterCognome.toLowerCase();
            filters['cognome'] = cogn;
        }

        if (this.filterCodFiscale) {
            const cf = this.filterCodFiscale.toLowerCase();
            filters['cod_fiscale'] = cf;
        }

        if (this.filterNumLibretto) {
            const lib = this.filterNumLibretto.toLowerCase();
            filters['codice_libretto'] = lib;
        }

        if (this.area_vasta_corrente_id) {
            filters['area_vasta_id'] = this.area_vasta_corrente_id;
        }

        if (this.libretto_cartaceo != null) {
            filters['libretto_cartaceo'] = this.libretto_cartaceo;
        }

        if (this.distretto_corrente_id) {
            filters['distretto_id'] = this.distretto_corrente_id;
        }

        if (this.struttura_corrente_id) {
            filters['consultorio_id'] = this.struttura_corrente_id;
        }

        if (this.stato_gravidanza) {
            filters['stato_gravidanza'] = this.stato_gravidanza;
        }

        if (this.created_from) {
            filters['created_from'] = this.datePipe.transform(this.created_from, 'yyyy-MM-dd');
        }

        if (this.created_to) {
            filters['created_to'] = this.datePipe.transform(this.created_to, 'yyyy-MM-dd');
        }

        const results = await this.hmService.listaGravidanze(filters, this.offset, this.limit, this.nascita).toPromise();
        this.full_count = results.full_count;

        this.items = _.orderBy(results.gravidanze, 'createdAt', 'desc');
    }

    async ngOnInit() {
        await this.updateItems();
    }

    statoGravidanza(stato) {
        return StatoGravidanza[stato];
    }

}
